import {
  Modal,
  Form,
  Input,
  Button,
  Select,
  message,
  Radio,
  Row,
  Col,
  Tabs,
  Checkbox,
} from 'antd';
import React, { useState } from 'react';
import IntlMessage from '../../../components/IntlMessage';
import CountryData from '../../../utils/countrydata';
import userOperatorApi from '../../../api/user-operator';

const { Option } = Select;

const opearator_user_roles = [
  {
    id: 1,
    role: 'cashier',
    attributes: ['agent_app'],
    values: ['Application'],
  },
  {
    id: 2,
    role: 'convoyeur',
    attributes: ['passenger_list'],
    values: ['Passagers'],
  },
  {
    id: 3,
    role: 'partner_manager',
    attributes: ['bookings', 'passenger_list', 'finance', 'report'],
    values: ['Bookings', 'Passagers', 'Finances', 'Report de voyage'],
  },
];
const AddUserOperatorForm = (props) => {
  const { openModal, currentData, onModalClose, onReload, userOprator } = props;
  const isMobile = window.innerWidth < 576;
  let initialValues = {
    firstname:
      currentData && currentData.firstname ? currentData.firstname : null,
    lastname: currentData && currentData.lastname ? currentData.lastname : null,
    username: currentData && currentData.username ? currentData.username : null,
    email: currentData && currentData.email ? currentData.email : null,
    mobile: currentData && currentData.mobile ? currentData.mobile : null,
    status: currentData && currentData.status ? 1 : 0,
    role:
      userOprator && userOprator.params
        ? JSON.parse(userOprator.params)?.role
        : null,
    attribute:
      userOprator && userOprator.params
        ? JSON.parse(userOprator.params)?.attribute
        : null,
  };

  const onFinish = (values) => {
    console.log('Success:', values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };

  const [form] = Form.useForm();

  const handleOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        const data = { ...values };
        if (data.role) {
          data.params = JSON.stringify({
            role: data.role,
            attribute: data.attribute,
          });
        }
        if (!data?.password) {
          delete data.password;
        }
        if (data.role) {
          delete data.role;
        }
        if (data.attribute) {
          delete data.attribute;
        }

        if (currentData) {
          const res = await userOperatorApi.update(currentData.id, data);
          if (res) {
            message.success('Successfully updated!');
            onModalClose();
            onReload();
          }
        } else {
          const res = await userOperatorApi.create(data);
          if (res) {
            message.success('Successfully created!');
            onModalClose();
            onReload();
          }
        }
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  const [role, setRole] = useState(null);

  const onChangeRole = (role) => {
    setRole(role);
    form.setFieldValue(
      'attribute',
      opearator_user_roles.find((i) => i.role === role)?.attributes || [],
    );
  };
  const roleValue = Form.useWatch('role', form);
  const tabItems = [
    {
      key: '1',
      label: <IntlMessage id="global.agent" />,
      children: (
        <>
          <Form.Item
            label={<IntlMessage id="global.firstname" />}
            name="firstname"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.required_field_firstname" />,
              },
            ]}>
            <Input />
          </Form.Item>

          <Form.Item
            label={<IntlMessage id="global.lastname" />}
            name="lastname"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.required_field_lastname" />,
              },
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.phone_code" />}
            name={'phone_code'}
            initialValue={'+221'}>
            <Select
              style={{ width: '100%' }}
              placeholder="Select phone code"
              showSearch
              defaultValue={`+221`}
              options={CountryData.map((country, i) => {
                return {
                  label: `(+${country.code}) ${country.country}`,
                  value: `+${country.code}`,
                };
              })}
            />
          </Form.Item>

          <Form.Item
            label={<IntlMessage id="global.mobile" />}
            name="mobile"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.required_field_mobile" />,
              },
              {
                message: <IntlMessage id={`validate.is_not_phone_number`} />,
                pattern: new RegExp(/^[0-9]+$/),
              },
            ]}>
            <Input />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.required_field_email" />,
              },
              {
                type: 'email',
                message: <IntlMessage id="validate.is_not_email" />,
              },
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.password" />}
            name="password"
            rules={[
              {
                required: currentData ? false : true,
                message: <IntlMessage id="global.required_field_password" />,
              },
            ]}>
            <Input.Password />
          </Form.Item>
        </>
      ),
    },
    {
      key: '2',
      label: <IntlMessage id="global.roles" />,
      children: (
        <>
          <Form.Item
            label={<IntlMessage id={`global.role`} />}
            labelCol={{ span: 4 }}
            name={'role'}
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.required_field_role" />,
              },
            ]}>
            <Select
              style={{ width: 500 }}
              showSearch
              onChange={onChangeRole}
              filterOption={false}
              options={opearator_user_roles.map((item, i) => {
                return {
                  label: <IntlMessage id={`select.${item.role}`} />,
                  value: item?.role,
                };
              })}
            />
          </Form.Item>
          {roleValue && (
            <Form.Item
              label={<IntlMessage id="global.access" />}
              name="attribute"
              rules={[
                {
                  required: false,
                  message: <IntlMessage id="global.requiredfield" />,
                },
              ]}>
              <Checkbox.Group
                options={(() => {
                  const roleConfig = opearator_user_roles.find(
                    (i) => i.role === roleValue,
                  );
                  const attributes = roleConfig?.attributes || [];
                  const labels = roleConfig?.values || [];

                  return attributes.map((attr, idx) => ({
                    label: labels[idx] ?? attr,
                    value: attr,
                  }));
                })()}
                onChange={(value) => {
                  console.log('checked', value);
                }}
                style={{ flexDirection: 'column' }}
              />
            </Form.Item>
          )}
        </>
      ),
    },
  ];

  return (
    <React.Fragment>
      <Modal
        title={
          currentData ? (
            <IntlMessage id="global.edit" />
          ) : (
            <IntlMessage id="global.add" />
          )
        }
        open={openModal}
        onCancel={onModalClose}
        width={isMobile ? '90%' : '50%'}
        footer={[
          <>
            <Button key="back" type="default" onClick={onModalClose}>
              {<IntlMessage id="global.cancel" />}
            </Button>
            <Button key="back" type="primary" onClick={handleOk}>
              {<IntlMessage id="global.save" />}
            </Button>
          </>,
        ]}>
        <Form
          name="basic"
          labelAlign="left"
          {...layout}
          className="ml-20"
          initialValues={initialValues}
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off">
          <Tabs defaultActiveKey="1" items={tabItems}></Tabs>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default AddUserOperatorForm;
